import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SavingTracker from '../components/SavingTracker';

const PageGoalSaving = () => {
  return (
    <div>
      <Navbar />
      <SavingTracker />
      {/* <Footer /> */}
    </div>
  );
};

export default PageGoalSaving;
